import React, { useRef } from 'react';

// Reusable 6-digit OTP input with paste + arrow-key support.
// Shared by register, forgot-password and reset-password flows.
const OtpInput = ({ value, onChange, disabled, length = 6 }) => {
  const refs = useRef([]);
  const digits = Array.from({ length }, (_, i) => value[i] || '');

  const handleKey = (i, e) => {
    if (e.key === 'Backspace') {
      const next = value.slice(0, i) + value.slice(i + 1);
      onChange(next);
      if (i > 0) refs.current[i - 1]?.focus();
      return;
    }
    if (e.key === 'ArrowLeft' && i > 0) { refs.current[i - 1]?.focus(); return; }
    if (e.key === 'ArrowRight' && i < length - 1) { refs.current[i + 1]?.focus(); return; }
    const ch = e.key.replace(/\D/g, '');
    if (!ch) return;
    const next = value.slice(0, i) + ch + value.slice(i + 1);
    onChange(next.slice(0, length));
    if (i < length - 1) refs.current[i + 1]?.focus();
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
    if (pasted) { onChange(pasted); refs.current[Math.min(pasted.length, length - 1)]?.focus(); }
    e.preventDefault();
  };

  return (
    <div className="otp-input-row">
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          className="otp-digit"
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={d}
          onChange={() => {}}
          onKeyDown={(e) => handleKey(i, e)}
          onPaste={handlePaste}
          disabled={disabled}
          autoFocus={i === 0}
        />
      ))}
    </div>
  );
};

export default OtpInput;
